function focusSignupFeedback(root = document) {
  if (window.Shopify?.designMode) return;

  const sections = root.matches?.('.real-campaign-signup')
    ? [root]
    : root.querySelectorAll('.real-campaign-signup');

  for (const section of sections) {
    const feedback = section.querySelector(
      '.real-campaign-signup__form [aria-invalid="true"], .real-campaign-signup__message--success'
    );

    if (!feedback) continue;

    requestAnimationFrame(() => {
      if (!feedback.isConnected) return;
      feedback.focus({ preventScroll: true });
      feedback.scrollIntoView({ block: 'center', behavior: 'instant' });
    });
  }
}

focusSignupFeedback();
document.addEventListener('shopify:section:load', (event) => focusSignupFeedback(event.target));
